import _ from 'lodash';
import { createSelectorCreator, defaultMemoize } from 'reselect';

// Create selector creator
const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);

export default createDeepEqualSelector;
